/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    [
      'חצות', 'בבוקר', 'בצהריים', 'אחה״צ', 'בערב', 'בלילה',
      'לפנות בוקר'
    ],
    [
      'חצות', 'בוקר', 'צהריים', 'אחר הצהריים', 'ערב', 'לילה',
      'לפנות בוקר'
    ],
    [
      'חצות', 'בבוקר', 'בצהריים', 'אחר הצהריים', 'בערב', 'בלילה',
      'לפנות בוקר'
    ]
  ],
  [
    [
      'חצות', 'בוקר', 'צהריים', 'אחה״צ', 'ערב', 'לילה',
      'לפנות בוקר'
    ],
    ,
    [
      'חצות', 'בוקר', 'צהריים', 'אחר הצהריים', 'ערב', 'לילה',
      'לפנות בוקר'
    ]
  ],
  [
    '00:00', ['06:00', '12:00'], ['12:00', '16:00'], ['16:00', '18:00'], ['18:00', '22:00'],
    ['22:00', '03:00'], ['03:00', '06:00']
  ]
];
